import { AddressSettingsAction } from '../../address/store/actions'
import { addressSettingsReducer } from '../../address/store/reducers'
import { CertficateSettingsAction } from '../../certificates/store/actions'
import { certificateSettingsReducer } from '../../certificates/store/reducers'
import { ContactsSettingsAction } from '../../contacts/store/actions'
import { contactsSettingsReducer } from '../../contacts/store/reducers'
import { DetailsSettingsAction, detailsSettingsReducer } from '../../details/store/reducers'
import {  SettingsState } from './store'

export const LOAD_SETTINGS_ACCOUNT_REQUEST = 'LOAD_SETTINGS_ACCOUNT_REQUEST'
export const LOAD_SETTINGS_ACCOUNT_RECEIVED = 'LOAD_SETTINGS_ACCOUNT_RECEIVED'
export const LOAD_SETTINGS_ACCOUNT_ERROR = 'LOAD_SETTINGS_ACCOUNT_ERROR'

export type SettingsAction =
  | CertficateSettingsAction
  | DetailsSettingsAction
  | AddressSettingsAction
  | ContactsSettingsAction

export function settingsReducer(state: SettingsState, action: SettingsAction) {
  return {
    details: detailsSettingsReducer(state.details, action as DetailsSettingsAction),
    certificates: certificateSettingsReducer(state.certificates, action as CertficateSettingsAction),
    address: addressSettingsReducer(state.address, action as AddressSettingsAction),
    contacts: contactsSettingsReducer(state.contacts, action as ContactsSettingsAction)
  }
}
